module.exports = function() {
  return new Worker(__webpack_public_path__ + "134cd754b69ba7aa8724.worker.js");
};